<div style="display: flex; justify-content: flex-end;">
  <button type="button" class="btn-close" [mat-dialog-close]=""></button>
</div>
<h1 mat-dialog-title class="m-0">Nuevo elemento POP</h1>

<div class="modal-body-scroll">
  <form class="inputform">
    <mat-form-field appearance="outline">
      <mat-label>Nombre </mat-label>
      <input matInput [(ngModel)]="dataR.nombre" name="nombre" required>
    </mat-form-field>
    <!--<mat-form-field appearance="outline">
      <mat-label>Elemento</mat-label>
      <mat-select [(ngModel)]="data.type" name="type" required>
        <mat-option *ngFor="let x of mattypes" [value]="x">
          {{ x }}
        </mat-option>
      </mat-select>
    </mat-form-field>-->
    <!-- <div class="row" *ngIf="media.allowMultipleItems && media.segmentable"> -->
    <div class="row">
      <!--anteriormente solo para formato 1-->
      <mat-slide-toggle [(ngModel)]="hasPosicion" name="select3">
        Tiene posiciones
      </mat-slide-toggle>
        <!--anteriormente solo para formato 2-->
      <div class="col-sm-6" *ngIf="media.formato == 2">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Prioridad</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="dataR.prioridad" (keydown)="mirror($event)" name="prioridad" step="-1">
          <mat-hint>1 es la prioridad más alta.</mat-hint>
        </mat-form-field>
      </div>
      <div *ngIf="hasPosicion" class="col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Posiciones</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="dataR.posiciones" name="posiciones" step="1">
        </mat-form-field>
      </div>
    </div>
    <!--<div *ngIf="media.allowMultipleItems">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Prioridad</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="data.priority" (keydown)="mirror($event)" name="priority" step="-1">
          <mat-hint>1 es la prioridad más alta.</mat-hint>
        </mat-form-field>
    </div>
    <div *ngIf="media.segmentable">
      <div>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Posiciones</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="data.placements" step="1">
        </mat-form-field>
      </div>
    </div>-->
    <div class="mb-4">
      <h5 class="fw-bold text-primary">Filtro sucursales</h5>
      <p *ngIf="reglasAlcance.length>0 && !loadedcal"><span class="tinyfont">Calculando sucursales...</span></p>
      <p *ngIf="reglasAlcance.length>0 && loadedcal"><span class="tinyfont">*Cantidad de sucursales filtradas : <b>{{ sucursalesCount }}</b></span></p>
      <div *ngFor="let regla of reglasAlcance; let i = index; trackBy: trackByFn" class="mb-3">
        <div class="row">
          <div class="col-md-3">
           <!--<mat-form-field appearance="outline" class="form-field">
              <mat-label>Atributo</mat-label>
              <mat-select [(ngModel)]="regla.id" name="atributo-{{i}}" (selectionChange)="setItemName($event.value, regla)">
                <mat-option *ngFor="let atributo of atributos" [value]="atributo.id">{{ atributo.name }}</mat-option>
              </mat-select>          
            </mat-form-field>--> 
            
            <attr-autocomplete [dataSource]="atributos"
            [(selectedId)]="regla.id" (selectedIdChange)="setItemName($event, regla)"></attr-autocomplete>
          </div>
          <div class="col-md-3">
            <mat-form-field *ngIf="getItem(regla.id) != null" appearance="outline" class="form-field">
              <mat-label>Condición</mat-label> 
              <mat-select [(ngModel)]="regla.operador" name="operador-{{i}}" (selectionChange)="onOperadorChange(regla)">
                <ng-container *ngIf="getItem(regla.id) as item">
                  <mat-option *ngIf="[1, 3, 4, 5, 6].includes(item.type_id)" [value]="1">Igual que</mat-option>
                  <mat-option *ngIf="[4, 6].includes(item.type_id)" [value]="2">Mayor que</mat-option>
                  <mat-option *ngIf="[4, 6].includes(item.type_id)" [value]="3">Menor que</mat-option>
                  <!--actua como un igual, pero selecciona cualquiera de los valores-->
                   <mat-option *ngIf="[1, 3, 4, 5, 6].includes(item.type_id)" [value]="4">Incluye</mat-option>
                </ng-container>

              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-5">
            <ng-container *ngIf="getItem(regla.id) as item">
              <mat-form-field *ngIf="regla.operador !== 4" appearance="outline" class="form-field">
                <mat-label>Valor</mat-label>
                <input matInput [hidden]="item.type_id != 4" [(ngModel)]="regla.valor" name="valor-{{i}}" (blur)="validateRangeAndCalculate(regla)" type="number" placeholder="Valor de {{getRanges(item.select_data)[0]}} a {{getRanges(item.select_data)[1]}}" min="{{getRanges(item.select_data)[0]}}" max="{{getRanges(item.select_data)[1]}}">
                <input matInput [hidden]="item.type_id != 6" [(ngModel)]="regla.valor" name="valor-{{i}}" (blur)="calculateStores()" type="number"  placeholder="Ej: 10" />
                <input matInput [hidden]="item.type_id != 5" [(ngModel)]="regla.valor" name="valor-{{i}}" (blur)="calculateStores()" placeholder="Ej: Valor" />
                <ng-container *ngIf="item.type_id == 3">
                  <mat-select  [(ngModel)]="regla.valor" (selectionChange)="calculateStores()" name="valor-{{i}}">
                    <mat-option *ngFor="let valor of converToObject(item.select_data)" [value]="valor">{{ valor }}</mat-option>
                  </mat-select>
                </ng-container>
                <ng-container *ngIf="item.type_id == 1" >
                  <mat-select  [(ngModel)]="regla.valor" name="valor-{{i}}" (selectionChange)="calculateStores()">
                    <mat-option [value]="'SI'">SI</mat-option>
                    <mat-option [value]="'NO'">NO</mat-option>
                </mat-select>
              </ng-container>
              </mat-form-field>
  
              <!-- "Incluye a" operator handling -->
              <ng-container *ngIf="regla.operador === 4">
                <!-- Input para añadir chips de texto/número (cuando NO es tipo Opciones) -->
                <mat-form-field *ngIf="item.type_id !== 3" appearance="outline" class="form-field chip-list-field">
                  <mat-label>Valores (separados por coma o Enter)</mat-label>
                  <mat-chip-list #chipList aria-label="Selección de valores">
                    <mat-chip *ngFor="let chip of regla.valor" (removed)="removeChip(regla, chip)">
                      {{chip}}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input class="mat-chip-input-custom"
                           [matChipInputFor]="chipList"
                           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                           [matChipInputAddOnBlur]="true"
                           (matChipInputTokenEnd)="addChip(regla, $event)">
                  </mat-chip-list>
                </mat-form-field>

                <!-- mat-select con [multiple] para tipo Opciones (type_id 3) -->
                <mat-form-field *ngIf="item.type_id === 3" appearance="outline" class="form-field">
                  <mat-label>Valores (Incluye a)</mat-label>
                  <mat-select [(ngModel)]="regla.valor" name="valor-multiple-{{i}}" (selectionChange)="calculateStores()" multiple>
                    <mat-option *ngFor="let option of converToObject(item.select_data)" [value]="option">{{option}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </ng-container>
          </div>
          <div class="col-md-1">
            <button mat-icon-button color="warn" (click)="eliminarRegla(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <button mat-flat-button color="primary" (click)="agregarRegla()">
        <mat-icon>add</mat-icon> Añadir Regla
      </button>
    </div>

    <div *ngIf="!isEdit" class="row">
      <mat-slide-toggle [(ngModel)]="generate_config" name="select44">
       Generar Configuración
      </mat-slide-toggle>

        <ng-container *ngIf="generate_config">

        <ng-container *ngIf="media.formato != 2 && media.formato != 3">
          <p *ngIf="media.formato != 2"><mat-slide-toggle [(ngModel)]="isQuantity" name="qnt">Cantidad fija</mat-slide-toggle></p>     
           <div class="mb-4"  *ngIf="media.formato != 2 && isQuantity">
             <h5 class="fw-bold text-primary">
               <mat-icon class="me-2 align-middle">inventory</mat-icon>Definir Cantidad
             </h5>
             <div>
             <div class="row align-items-center"> 
                 <div class="col-md-6">
                   <mat-form-field appearance="outline" class="w-100">
                     <mat-label>Cantidad</mat-label>
                     <input matInput type="number" min="1" [(ngModel)]="dataR.cantidad" name="cantidad" step="-1">
                   </mat-form-field>
               </div> 
             </div>
           </div>
           </div>

        
          <div class="mb-4" *ngIf="!isQuantity">
          <div class="row align-items-center"> 
            <div class="col-md-4">
            
              <attr-autocomplete [dataSource]="numericalAtributes"
              [(selectedId)]="prioridadConf[0].id" (selectedIdChange)="setItemName2($event,prioridadConf[0])"></attr-autocomplete>
              </div>
            
            <div class="col-md-3 d-flex justify-content-center">
              <span class="x-label">Multiplicado por:</span> 
            
            </div>
          
            <div class="col-md-3">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Valor</mat-label>
                <input [(ngModel)]="prioridadConf[0].multiplicador" name="multiplicadorc" matInput placeholder="Ej: 10" />
              </mat-form-field>
            </div>
          </div>
        </div>
        </ng-container>


        <div class="mb-4">
          <h5 class="fw-bold text-primary">
            <mat-icon class="me-2 align-middle">attach_money</mat-icon>Definir Precio
          </h5>
          <div>
          <div class="row align-items-center"> 
              <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Precio</mat-label>
                  <input matInput type="number" min="1" [(ngModel)]="dataR.precio" name="precio" step="-1">
                </mat-form-field>
            </div>
          </div>
        </div>
        </div>
        
      </ng-container>
      <ng-container *ngIf="!isEdit">
        <p><mat-slide-toggle [(ngModel)]="generatePoPs" name="genPop">Generar múltiples</mat-slide-toggle></p>    
  
        <ng-container *ngIf="generatePoPs">
          <div class="row">
            <div class="col-sm-6">
          <mat-form-field appearance="outline">
            <mat-label>Número de versiones: </mat-label>
            <input matInput [(ngModel)]="generateSettings.cantidadPoPs" name="cantidadEx">
          </mat-form-field>
            </div>
            <div class="col-sm-6">
          <mat-form-field appearance="outline">
            <mat-label>Postfijo: </mat-label>
            <input matInput [(ngModel)]="generateSettings.postfijo" placeholder="*Opcional" name="postfijoEx">
          </mat-form-field>
            </div>
          </div>

        </ng-container>
  
  
      </ng-container>
    </div>

  </form>
</div>
<div mat-dialog-actions class="button-container">
  <button mat-raised-button *ngIf="!isEdit" class="nest-button" (click)="register()" [disabled]="invalidInput()">Agregar</button>
  <button mat-raised-button *ngIf="isEdit" class="nest-button" (click)="edit()" [disabled]="invalidInput()">Editar</button>
</div>